import CONST from 'const'
import Konva from 'konva'
import { cloneDeep } from 'lodash'
import React, { useState } from 'react'
import { Circle, Group } from 'react-konva'
import { jsonParse } from 'utils/json'

interface Props {
  selectedMaterials: Array<number | string>
  material: ReduxStore.Materials.Data.IMaterial
  scale: { x: number; y: number }
  onMouseDown: (
    evt: Konva.KonvaEventObject<MouseEvent>,
    material: ReduxStore.Materials.Data.IMaterial
  ) => void
  onDragStart: (overlayId: string | number) => void
  onDragMove: (
    evt: Konva.KonvaEventObject<MouseEvent>,
    material: ReduxStore.Materials.Data.IMaterial
  ) => void
  onDragEnd: (
    evt: Konva.KonvaEventObject<MouseEvent>,
    material: ReduxStore.Materials.Data.IMaterial
  ) => void
  dispatchUpdateCirclePos: (newPos: ReduxStore.Materials.Data.INewCirclePos) => void
}

const Point: React.FC<Props> = props => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  
  const {
    selectedMaterials,
    material,
    scale,
    onMouseDown,
    onDragStart,
    onDragMove,
    onDragEnd,
    dispatchUpdateCirclePos,
  } = props
  
  const { overlay_id, shape_data } = material
  const selected = selectedMaterials.some(id => id === overlay_id)
  const color = selected ? CONST.OVERLAY_YELLOW : CONST.OVERLAY_BLUE
  
  const shapeData = jsonParse(shape_data)
  if (!shapeData) {
    return <></>
  }
  
  const { position, radius = 25 } = shapeData
  if (!position || position.length !== 2) {
    return <></>
  }
  
  const handleDragEnd = (evt: Konva.KonvaEventObject<MouseEvent>) => {
    evt.cancelBubble = true
    const posX = evt.target.x()
    const posY = evt.target.y()
    
    // Update the position of the point
    const newMaterial = cloneDeep(material)
    const newShapeData = jsonParse(newMaterial.shape_data)
    if (newShapeData) {
      newShapeData.position = [posX, posY]
      newMaterial.shape_data = JSON.stringify(newShapeData)
    }
    
    onDragEnd(evt, newMaterial)
  }
  
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  
  // Use fixed pixel size for display (consistent regardless of zoom)
  const displayRadius = radius;
  
  return (
    <Group
      ref={instance => instance && window.shapeRefs.push(instance)}
      key={`${overlay_id}-${JSON.stringify(position)}-${radius}`}
      shapeId={overlay_id}
      name={overlay_id.toString()}
      materialBelongsTo={overlay_id}
      shape="point"
    >
      <Circle
        draggable={selected}
        x={position[0]}
        y={position[1]}
        radius={displayRadius}
        fill={color}
        stroke={selected ? "red" : undefined}
        strokeWidth={selected ? 2 : 0}
        strokeScaleEnabled={false}
        onMouseDown={evt => onMouseDown(evt, material)}
        onDragStart={() => onDragStart(overlay_id)}
        onDragMove={evt => onDragMove(evt, material)}
        onDragEnd={handleDragEnd}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    </Group>
  )
}

export default Point
